import { render } from "./ContactUs.vue?vue&type=template&id=7be491f0&scoped=true&ts=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=7be491f0&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be491f0"]])

export default __exports__